import { FormBuilder, Validators } from '@angular/forms';
import { Examen } from '../Examen.config';
import { apellidoNombreTrabajadorValidator } from '../../../../../utils/apellido-nombre-trabajador-validator';

export class EstudioColumnaLumbosacra extends Examen {
	id = 5;
	code = 'COLUM';
	name = 'PROTOCOLO POSICIONES FORZADAS Y GESTOS REPETITIVOS EN LA COLUMNA LUMBOSACRA';
	baseUrl = 'estudios/carga';
	isAttachedFileRequire = false;
	sections = [
		{
			name: 'PROTOCOLO POSICIONES FORZADAS Y GESTOS REPETITIVOS EN LA COLUMNA LUMBOSACRA',
			fields: {
				fechaRealizacion: ['', [Validators.required]],
			},
		},
		{
			name: 'Empleador',
			fields: {},
			numberForm: 1,
		},
		{
			name: 'Trabajador',
			fields: {
				apellidoNombre:['', [Validators.required, Validators.maxLength(100), apellidoNombreTrabajadorValidator]],
				fechaNacimiento: ['', [Validators.required]],    
				puestoTrabajador: ['', [Validators.required]],
				fechaIngresoEmpresa: ['', [Validators.required]],
				antiguedadPuestoTrabajador: ['', [Validators.required]],
			},
			numberForm: 2,
		},
		{
			name: 'Estudio',
			fields: {
				tareaHabitual: ['', [Validators.required, Validators.maxLength(1000)]],
				antecedentesLaboralesActividad: [false, [Validators.required]],
				antecedentesLaboralesDescripcion: [{value: '', disabled: true}, [Validators.required, Validators.maxLength(1000)]],
			},
			numberForm: 3,
		},
		{
			name: 'TiempoDeTarea',
			fields: {
				tiempoTareaDiaria: [null, [Validators.required, Validators.min(0), Validators.max(9999)]],
				tiempoTareaSemanal: [null, [Validators.required, Validators.min(0), Validators.max(9999)]],
			},
			numberForm: 4,
		},
		{
			name: 'ManipulacionManualDeCargas',
			fields: {
				manipulacionCarga: ['manipulacionCargaMenora10', [Validators.required]],
				manipulacionCargaMenora10: [true, [Validators.required]],
				manipulacionCargaEntre10y20: [false, [Validators.required]],
				manipulacionCargaMayora20: [false, [Validators.required]],
			},
			numberForm: 5,
		},
		{
			name: 'EvaluacionClinica',
			fields: {
				curFisEjeAnterposterior: ['N', [Validators.required, Validators.maxLength(2)]],
				desEjeLateral: ['N', [Validators.required, Validators.maxLength(2)]],
				palpacionNormal: [true, [Validators.required]],
				palpacionApofosisEspinosa: [false, [Validators.required]],
				palpacionContracturaMuscular: [false, [Validators.required]],
				movDolorNormal: [true],
				movDolorFlexion: [false],
				movDolorExtension: [false],
				movDolorLateralizacionIzq: [false],
				movDolorLateralizacionDer: [false],
				movDolorRotacionIzq: [false],
				movDolorRotacionDer: [false],
				movDolorIrradiacion: [false],
				movDolorIrradiacionDescripcion: [{value: '', disabled: true}, [Validators.required, Validators.maxLength(1000)]],
				lasegueDerecho: ['', [Validators.required]],
				lasegueDerechoP: [null],
				lasegueDerechoN: [null],
				lasegueIzquierdo: ['', [Validators.required]],
				lasegueIzquierdoP: [null],
				lasegueIzquierdoN: [null],
				bragardDerecho: ['', [Validators.required]],
				bragardDerechoP: [null],
				bragardDerechoN: [null],
				bragardIzquierdo: ['', [Validators.required]],
				bragardIzquierdoP: [null],
				bragardIzquierdoN: [null],
				halluxDerecho: ['', [Validators.required]],
				halluxDerechoP: [null],
				halluxDerechoN: [null],
				halluxIzquierdo: ['', [Validators.required]],
				halluxIzquierdoP: [null],
				halluxIzquierdoN: [null],
				valsalva: ['', [Validators.required]],
				valsalvaP: [null],
				valsalvaN: [null],
				patelarDerecha: ['', [Validators.required]],
				patelarDerechaH: [null],
				patelarDerechaA: [null],
				patelarDerechaN: [null],
				patelarIzquierda: ['', [Validators.required]],
				patelarIzquierdaH: [null],
				patelarIzquierdaA: [null],
				patelarIzquierdaN: [null],
				aquilianorDerecha: ['', [Validators.required]],
				aquilianorDerechaH: [null],
				aquilianorDerechaA: [null],
				aquilianorDerechaN: [null],
				aquilianorIzquierda: ['', [Validators.required]],
				aquilianorIzquierdaH: [null],
				aquilianorIzquierdaA: [null],
				aquilianorIzquierdaN: [null],
				grado0: [true, [Validators.required]],
				grado1: [false, [Validators.required]],
				grado2: [false, [Validators.required]],
				grado3: [false, [Validators.required]],
				grado4: [false, [Validators.required]],
			},
			numberForm: 6,
		},
		{
			name: 'Observaciones',
			fields: {
				observaciones: ['', [Validators.required, Validators.maxLength(1000)]],
			},
			numberForm: 7,
		},
		{
			name: 'Dictamen medico',
			fields: {
				medicoNombre: [null, [Validators.required, Validators.pattern(/^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\s]+$/)]],
				codigoDictamen: [null, [Validators.required]],
				medicoMatricula: [null, [Validators.required]],
				medicoEspecialidad: [null, [Validators.required]],
			},
			numberForm: 8,
		},
		{
			name: 'Adjuntos',
			fields: {},
			numberForm: 9,
		},
	];

	constructor(formBuilder: FormBuilder) {
		super(formBuilder);
		this.fieldList = this.getFields();
		this.examForm = this.getForm();
		this.sectionsList = this.getSections();
	}
}
